// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import mainSlideshow from './js/widgets/mainSlideshow.js';
import mainCards from './js/widgets/mainCards.js';
import * as videoSeo from './js/widgets/video-seoBlock/index.js';
import renderEventsSection from './js/widgets/events-section/renderEventsSection.js';
import customSignup from './js/widgets/customSignup.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    mainCards();
    videoSeo.seoBlock();
    $(globalThis).on('load', function () {
      videoSeo.videoWidget();
    });
    renderEventsSection();
    scrollerSponsors();
  }

  customSignup();
});
